<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">
        <span class="title-span"> {{ 'aumico_reports_company_valuation_dialog_title' | i18next }}</span>
    </div>
    <div class="seprator"></div>
    <div class="close-dialog">
        <mat-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </mat-dialog-actions>
    </div>
</div>
<div mat-dialog-content>
    <div class="dialog-text-content">
        <span>
            <!--Content-->
            {{ 'aumico_reports_company_valuation_dialog_text' | i18next }}
        </span>
    </div>

    <div class="selection-title">
        <span> {{ 'aumico_reports_company_valuation_dialog_select_company' | i18next }} : </span>
    </div>

    <div>
        <mat-form-field appearance="fill">
            <input
                type="text"
                placeholder="Search company name"
                aria-label="Number"
                matInput
                [formControl]="companyControl"
                [matAutocomplete]="auto"
            />
            <!-- Prefix icon -->
            <mat-icon matPrefix>search</mat-icon>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let company of filteredCompanies" [value]="company">
                    {{ company.name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="onPlaceOrderClick()" [disabled]="companyControl.value == null" color="blue">
            {{ 'aumico_reports_company_valuation_dialog_place_order_button_text' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
